import env from './env'

export const baseUrl = env.REACT_APP_API_BASE_URL;